module.exports = __webpack_public_path__ + "assets/svg/Icons/32/document-red-6d51ea.svg";